const initialState = {
  isConfigLoading: true,
  isGroupScopedSelected: false,
  filteredGroups: [],
  selectedGroups: [],
  totalGroupsCount: 0,
  isGroupsLoading: true,
  isGroupsCreateLoading: false,
  integrationScopes: []
}

const setIsConfigLoading = (state, isConfigLoading) => ({
  ...state,
  isConfigLoading,
})

const setIsGroupScopedSelected = (state, isGroupScopedSelected) => ({
  ...state,
  isGroupScopedSelected,
})

const setFilteredGroups = (state, data) => ({
  ...state,
  filteredGroups: data
})

const toggleSelectedGroup = (state, uuid) => {
  let newSelected = []

  if (state.selectedGroups.includes(uuid)) {
    newSelected = state.selectedGroups.filter((g) => g !== uuid)
  } else {
    newSelected = [...state.selectedGroups, uuid]
  }

  return {
    ...state,
    selectedGroups: newSelected,
  }
}

const resetSelectedGroups = (state) => ({
  ...state,
  selectedGroups: state.integrationScopes.map((s) => s.owner_uuid),
})

const setTotalGroupsCount = (state, data) => ({
  ...state,
  totalGroupsCount: data
})

const setIsGroupsLoading = (state, isGroupsLoading) => ({
  ...state,
  isGroupsLoading,
})

const setIsGroupsCreateLoading = (state, isGroupsCreateLoading) => ({
  ...state,
  isGroupsCreateLoading,
})

const setIntegrationScopes = (state, data) => ({
  ...state,
  integrationScopes: data,
  selectedGroups: data.map((s) => s.owner_uuid),
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SALESFORCE_SET_CONFIG_LOADING':
      return setIsConfigLoading(state, payload)
    case 'SALESFORCE_SET_GROUP_SCOPED_SELECTED':
      return setIsGroupScopedSelected(state, payload)
    case 'SALESFORCE_TOGGLE_SELECTED_GROUP':
      return toggleSelectedGroup(state, payload)
    case 'SALESFORCE_RESET_SELECTED_GROUPS':
      return resetSelectedGroups(state, payload)
    case 'SALESFORCE_FETCH_GROUPS':
      return setIsGroupsLoading(state, true)
    case 'SALESFORCE_FETCH_GROUPS_SUCCESS':
      return setFilteredGroups(state, payload.collection)
    case 'SALESFORCE_FETCH_GROUPS_TOTAL_SUCCESS':
      return setTotalGroupsCount(state, payload)
    case 'SALESFORCE_FETCH_GROUPS_COMPLETE':
      return setIsGroupsLoading(state, false)
    case 'SALESFORCE_CREATE_INTEGRATION_SCOPES':
      return setIsGroupsCreateLoading(state, true)
    case 'SALESFORCE_CREATE_INTEGRATION_SCOPES_SUCCESS':
      return setIntegrationScopes(state, payload.collection)
    case 'SALESFORCE_CREATE_INTEGRATION_SCOPES_COMPLETE':
      return setIsGroupsCreateLoading(state, false)
    case 'SALESFORCE_FETCH_INTEGRATION_SCOPES_SUCCESS':
      return setIntegrationScopes(state, payload.collection)
    case 'INTEGRATION_SCOPE_DELETE_SUCCESS':
      return setIntegrationScopes(state, state.integrationScopes.filter((scope) => (scope.uuid !== payload)))
    case 'INTEGRATION_SCOPE_DELETE_BULK_SUCCESS':
      return setIntegrationScopes(state, payload)
    default:
      return state
  }
}
